import { gql } from '@apollo/client'

export const REMOVE_ORDER_SERVICE_LINE_ITEMS = gql`
  mutation RemoveOrderServiceLineItems($serviceLineItemIds: [ID!]!) {
    removeOrderServiceLineItems(serviceLineItemIds: $serviceLineItemIds) {
      deletedServiceLineItems {
        id
      }
      errors
    }
  }
`
